import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const Quote = styled.div`
  position: relative;
  background: white;
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  padding: 5%;
  font-size: 22px;
  line-height: 34px;
  box-sizing: border-box;
  margin: 5%;
  &:before {
    content: '';
    display: inline-block;
    position: absolute;
    top: -8px;
    left: 50%;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;

    border-bottom: 8px solid white;
  }
  span {
    &:before {
      content: '"';
    }
    &:after {
      content: '"';
    }
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin: 2.5%;
  }
`;

export default Quote;



// WEBPACK FOOTER //
// ./src/styled-components/Quote.js